import { render, staticRenderFns } from "./ModalQuestion.vue?vue&type=template&id=42f370f1&scoped=true"
import script from "./ModalQuestion.vue?vue&type=script&lang=js"
export * from "./ModalQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalQuestion.vue?vue&type=style&index=0&id=42f370f1&prod&lang=scss&scoped=true"
import style1 from "./ModalQuestion.vue?vue&type=style&index=1&id=42f370f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f370f1",
  null
  
)

export default component.exports